/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/




(function () {
  "use strict";

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }

  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };


  // at - add cart item with properties
  async function addItemWithProperty(data) {
    await fetch("/cart/add.js", {
      method: "POST",
      body: data,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
    .then((data) => {
      document.dispatchEvent(new CustomEvent("cart:build"));
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  };

  // at - set cookie
  function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  };
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  };
  function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };

  // at - get elements ready stat
  function elementReady(selector) {
    return new Promise((resolve, reject) => {
      let el = document.querySelector(selector);
      if (el) {
        resolve(el); 
        return
      }
      new MutationObserver((mutationRecords, observer) => {
        // Query for elements matching the specified selector
        Array.from(document.querySelectorAll(selector)).forEach((element) => {
          resolve(element);
          //Once we have resolved we don't need the observer anymore.
          observer.disconnect();
        });
      })
        .observe(document.documentElement, {
          childList: true,
          subtree: true
        });
    });
  }



  // at - Free Single Product Modal popup
  function freeSingleProductModal() {
    // resize modal column
    function tbm_modalResize() {
      let tbm_modalRColH = document.querySelector(
        ".tbm_modal-right-col"
      ).offsetHeight;
      document.querySelector(".tbm_modal-left-col").style.height =
        tbm_modalRColH + "px";
    }
    tbm_modalResize();
    window.addEventListener(
      "resize",
      function (event) {
        tbm_modalResize();
      },
      true
    );

    let modalTriggerButton = document.querySelector(".tbm_modal_trigger");
    let modalContainerDiv = document.querySelector(".tbm_modal-container");
    let tbmModalCookieExpireSet = theme.fspmodal.cookieExpires;
    let tbmModalCookieName = "__tbm_modal_cookie";

    function modalContainer(key) {
      if (key == "hide") {
        modalContainerDiv.style.display = "none";
      }
      if (key == "show") {
        modalContainerDiv.style.display = "block";
      }
    }
    
    if (theme.fspmodal.cookieExpires == "-1") {
      //Cookies.remove(tbmModalCookieName, { path: "" });
      eraseCookie(tbmModalCookieName);
      console.log("FG modal cookie removed");
    }

    // set cookie, show popup
    if (getCookie(tbmModalCookieName) != "1") {
      elementReady('#bayengageEmbedForm form').then((form) => {
        setTimeout(function () {
          tbm_modalResize();
          //$('.tbm_modal-container').fadeIn(600);
          modalContainer("show");
          tbm_modalResize();
        }, theme.fspmodal.cookieModalDelay);
        //Cookies.set(tbmModalCookieName, "1", {
          //expires: tbmModalCookieExpireSet,
        //});
      });
      
      setCookie(tbmModalCookieName,1,tbmModalCookieExpireSet)
    } else {
      console.log("FG popup - already visited");
    }

    // close modal
    document
      .querySelector(".tbm_modal-close")
      .addEventListener("click", function (e) {
        e.preventDefault();
        modalContainer("hide");
      });
    document
      .querySelector(".tbm_modal-clickable")
      .addEventListener("click", function (e) {
        e.preventDefault();
        modalContainer("hide");
      });

    // trigger modal
    modalTriggerButton.addEventListener("click", function (e) {
      e.preventDefault();
      modalContainer("show");
      tbm_modalResize();
    });
    

    // check if BayEngage form ready
    elementReady('#bayengageEmbedForm form').then((form) => {
      modalTriggerButton.style.display = "block";
      tbm_modalResize();
      form.addEventListener("submit", (event) => {
          // add free product to cart
          var itemData = JSON.stringify({
            quantity: 1,
            id: theme.fspmodal.freeProdId,
            properties: { _modalfree: "true" },
          });
          addItemWithProperty(itemData);
          
          setTimeout(function () {
            document.getElementById("HeaderCartTrigger").click();
          }, 2000);
    
          // close modal
          setTimeout(function () {
            modalContainer("hide");
          }, 5000);
      });
    });
  };
  

  // at - wholesale info modal popup
  function wholesaleInfoModal() {
    let wimContainerDiv = document.querySelector(".wim-container");
    let wimCookieExpires = theme.wim.cookieExpires;
    let wimCookieName = "__wim_cookie";

    function wimContainer(key) {
      if (key == "hide") {
        wimContainerDiv.style.display = "none";
      }
      if (key == "show") {
        wimContainerDiv.style.display = "block";
      }
    }

    if (theme.wim.cookieExpires == "-1") {
      //Cookies.remove(wimCookieName, { path: "" });
      eraseCookie(wimCookieName);
      //console.log("WIM cookie removed");
    }

    // set cookie, show popup
    if (getCookie(wimCookieName) != "1") {
      setTimeout(function () {
        wimContainer("show");        
      }, theme.wim.cookieModalDelay);
      //Cookies.set(wimCookieName, "1", {
        //expires: wimCookieExpires,
      //});
      setCookie(wimCookieName,1,wimCookieExpires)
    } else {
      //console.log("WIM - already visited");
    }

    // close modal
    document
      .querySelector(".wim-close-msg")
      .addEventListener("click", function (e) {
        e.preventDefault();
        wimContainer("hide");
      });
    document
      .querySelector(".wim-close-btn")
      .addEventListener("click", function (e) {
        e.preventDefault();
        wimContainer("hide");
      });
    document
      .querySelector(".wim-clickable")
      .addEventListener("click", function (e) {
        e.preventDefault();
        wimContainer("hide");
      });
  };

  
  /* custom tabs - old site PDP content */
  function pdpTabAccordion() {
    var d = document,
      tabs = d.querySelector(".product-block .tabs"),
      tab = d.querySelectorAll(
        ".product-block .tabs > li > a"
      ),
      contents = d.querySelectorAll(
        ".product-block .tabs-content > li"
      );

    if (typeof(tabs) != 'undefined' && tabs != null) {
      tabs.addEventListener("click", function (e) {
        e.preventDefault();
        if (e.target && e.target.nodeName === "A") {
          if (e.target.matches(".active")) {
            return;
          }
  
          // change tabs
          for (var i = 0; i < tab.length; i++) {
            tab[i].classList.remove("active");
          }
          e.target.classList.toggle("active");
  
          // change content
          for (var i = 0; i < contents.length; i++) {
            contents[i].classList.remove("active");
          }
  
          var tabId = getHash(e.target.getAttribute("href"));
          d.getElementById(tabId).classList.toggle("active");
        }
      });
    }

    function getHash(url) {
      var hashPos = url.lastIndexOf("#");
      return url.substring(hashPos + 1);
    }
  };

    

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent("page:loaded"));

    if (theme.fspmodal.isEnabled) {
      freeSingleProductModal();
    }
    if (theme.wim.isEnabled) {
      if (window.location.pathname.indexOf(theme.wim.trigerContains) !== -1) {
        wholesaleInfoModal();  
      }      
    }
    if (window.location.pathname.indexOf("/products/") !== -1) {
      pdpTabAccordion();
    }
    
  });
})();
